import React, { Component } from "react";
import { Mutation } from "react-apollo";
import gql from "graphql-tag";
import { handleUnauthorized } from "../utils";

const PASSWORD_CHANGE_REQUEST = gql`
  mutation PasswordChangeRequest($email: String!) {
    requestReset(email: $email) {
      email
    }
  }
`;

class ForgotPassword extends Component {
  state = {
    email: "",
    message: "",
  };

  checkUnauthorized(error) {
    handleUnauthorized(error, this.props.history)
  }

  render() {
    const { email } = this.state;
    return (
      <Mutation
        mutation={PASSWORD_CHANGE_REQUEST}
        variables={{ email }}
        onError={(err) => {
          this.checkUnauthorized(err)
          if (err.graphQLErrors && err.graphQLErrors.length) {
            this.setState({
              message: err.graphQLErrors[0],
            });
          } else {
            this.setState({
              message: "An error occured when requesting a new password",
            });
          }
        }}
        onCompleted={({ requestReset: { email } }) => {
          this.setState({
            message: `Email sent to ${email}`,
          });
        }}
      >
        {(passwordChangeRequest) => (
          <div>
            <h4 className="mv3">Password Reset</h4>
            <div className="flex flex-column">
              <input
                value={email}
                onChange={(e) =>
                  this.setState({ email: e.target.value, message: "" })
                }
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    passwordChangeRequest();
                  }
                }}
                type="email"
                placeholder="Email"
              />
            </div>
            {!!this.state.message.length && (
              <div className="pt2 pl1">{this.state.message}</div>
            )}
            <div className="flex mt2">
              <button
                type="submit"
                className="pointer mr2 button sg_reset-pw"
                onClick={passwordChangeRequest}
              >
                Reset password
              </button>
            </div>
          </div>
        )}
      </Mutation>
    );
  }
}

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/components/ForgotPassword.js